export default __webpack_public_path__ + "static/media/red-round.b68269ba.svg";